import { render } from "./ReportGroupForm.vue?vue&type=template&id=11afbf8d"
import script from "./ReportGroupForm.vue?vue&type=script&lang=js"
export * from "./ReportGroupForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.14.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__